'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002427 from "./presto.-Dashboard-View$$anon$27.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002429 from "./presto.-Dashboard-View$$anon$29.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dAccount$002dResponse$0024 from "./presto.types$-Dashboard-Account-Response$.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dScope$0024 from "./presto.types$-Dashboard-Scope$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$26(outer) {
  this.aLN = null;
  this.aLF = null;
  this.aLG = false;
  this.aLO = null;
  this.aLP = false;
  this.aLS = null;
  this.aLL = null;
  this.aLM = false;
  this.aLH = null;
  this.aLI = false;
  this.aLJ = null;
  this.aLK = false;
  this.aLQ = false;
  this.aLR = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aLN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aLS = "DashboardAccountResponse";
}
export { $c_Lpresto_DashboardView$$anon$26 as $c_Lpresto_DashboardView$$anon$26 };
$p = $c_Lpresto_DashboardView$$anon$26.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$26;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$26() {
}
export { $h_Lpresto_DashboardView$$anon$26 as $h_Lpresto_DashboardView$$anon$26 };
$h_Lpresto_DashboardView$$anon$26.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aLN;
});
$p.M = (function() {
  if ((!this.aLG)) {
    this.aLF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aLG = true;
  }
  return this.aLF;
});
$p.O = (function() {
  if ((!this.aLP)) {
    this.aLO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aLP = true;
  }
  return this.aLO;
});
$p.D = (function() {
  return this.aLS;
});
$p.t = (function() {
  if ((!this.aLM)) {
    this.aLL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentialsByKind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("activeUsers", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("registeredUsers", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("scope", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("accounts", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aLM = true;
  }
  return this.aLL;
});
$p.N = (function() {
  if ((!this.aLI)) {
    this.aLH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002427.$c_Lpresto_DashboardView$$anon$27())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDashboard$002dScope$0024.$m_Lpresto_types$DashboardScope$().cII(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aLI = true;
  }
  return this.aLH;
});
$p.Q = (function() {
  if ((!this.aLK)) {
    this.aLJ = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002429.$c_Lpresto_DashboardView$$anon$29();
    this.aLK = true;
  }
  return this.aLJ;
});
$p.v = (function() {
  if ((!this.aLR)) {
    this.aLQ = false;
    this.aLR = true;
  }
  return this.aLQ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee162) => ((p) => \u03b4scrutinee162.cHm(p)))($j_presto$002etypes$0024$002dDashboard$002dAccount$002dResponse$0024.$m_Lpresto_types$DashboardAccountResponse$())));
});
var $d_Lpresto_DashboardView$$anon$26 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$26, "presto.DashboardView$$anon$26", ({
  H0: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$26 as $d_Lpresto_DashboardView$$anon$26 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$26.js.map
